type HandleNextFunction = () => void;
type HandleShareFunction = () => void;
type SwitchToNextVariantFunction = () => void;

let handleNextFunction: HandleNextFunction | null = null;
let handleShareFunction: HandleShareFunction | null = null;
let switchToNextVariantFunction: SwitchToNextVariantFunction | null = null;

export const setHandleNextFunction = (fn: HandleNextFunction | null) => {
  handleNextFunction = fn;
};

export const setHandleShareFunction = (fn: HandleShareFunction | null) => {
  handleShareFunction = fn;
};

export const setSwitchToNextVariantFunction = (
  fn: SwitchToNextVariantFunction | null,
) => {
  switchToNextVariantFunction = fn;
};

export const goToNext = async (): Promise<{
  success: boolean;
  error?: string;
}> => {
  if (!handleNextFunction) {
    return {
      success: false,
      error: 'Next handler not initialized',
    };
  }

  try {
    handleNextFunction();
    return {
      success: true,
    };
  } catch (error) {
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Unknown error occurred',
    };
  }
};

export const shareGeneration = async (): Promise<{
  success: boolean;
  error?: string;
}> => {
  if (!handleShareFunction) {
    return {
      success: false,
      error: 'Share handler not initialized',
    };
  }

  try {
    handleShareFunction();
    return {
      success: true,
    };
  } catch (error) {
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Unknown error occurred',
    };
  }
};

export const switchToNextVariant = async (): Promise<{
  success: boolean;
  error?: string;
}> => {
  if (!switchToNextVariantFunction) {
    return {
      success: false,
      error: 'Switch variant handler not initialized',
    };
  }

  try {
    switchToNextVariantFunction();
    return {
      success: true,
    };
  } catch (error) {
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Unknown error occurred',
    };
  }
};
